export default {
    title: 'Notification settings',
    text: 'You will be informed {selectedOption} about new micro-trends via e-mail.',
    info: 'You will be informed via e-mail when search agents identify new micro-trends. The notification settings apply for you personally and can be set individually by each participant of the work space.',
    button: 'Update',
    options: {
        off: 'no notification',
        daily: 'daily',
        weekly: 'weekly',
        monthly: 'monthly'
    },
    selection: {
        off: 'not',
        daily: 'daily',
        weekly: 'weekly',
        monthly: 'monthly'
    },
    success: {
        changed:
      'Your notification settings were successfully updated. ' +
      'You will be informed {selectedOption} about new micro-trends via e-mail.',
        unsubscribed:
      'Your notification settings were successfully updated. ' +
      'You will not be informed about new micro-trends via e-mail.'
    }
}
